<template>
  <v-dialog persistent :width="popupWidth" :value="vModel" :fullscreen="fullView">
    <slot></slot>
  </v-dialog>
</template>

<script>
export default {
  props: ["vModel", "fullView"],
  data() {
    return {
    };
  },
  computed: {
      popupWidth() {
      switch (this.$vuetify.breakpoint.name) {
      // The width
        // Range - "max 600px"
        case "xs":
          return "90vw";
        // Range - "min 600px, max 960px"
        case "sm":
          return "90vw";
        // Range - "min 960px, max 1264px"
        case "md":
          return "50vw";
        // Range - "min 1264px, max 1904px"
        case "lg":
          return "50vw";
         // Range - "min 1904px"
        case "xl":
          return "50vw";
      }
    },
  },
  methods: {
  },
};
</script>
<style></style>
